import React from "react";
import { Spinner } from "react-bootstrap";
import EmptyFeedCard from "../../../../_uiComponents/EmptyFeedCard";
import { fixImageUrl } from "../../../../_helpers/fixImageUrl";

function MentorSearch({
  mentorSearch,
  onViewMentorProfileClick,
  mentorLoading,
}) {
  return (
    <div>
      {mentorLoading ? (
        <div className="d-flex justify-content-center align-items-center w-100">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
          <h2 className="mb-4">Showing {mentorSearch?.length} Result</h2>
          {Array.isArray(mentorSearch) && mentorSearch.length ? (
            <div className="row">
              {mentorSearch &&
                Array.isArray(mentorSearch) &&
                mentorSearch.map((data) => (
                  <div className="col-md-4 mb-4">
                    <div className="p-4 bg-white border position-relative h-100 border-radius-10 shadow-2">
                      <div className="upper border-bottom">
                        <div className="d-flex mb-3 align-items-start">
                          <img
                            src={
                              data?.user_details?.user_meta_info?.profile_image
                                ? fixImageUrl(
                                    data?.user_details?.user_meta_info
                                      ?.profile_image
                                  )
                                : "/assets/images/user.png"
                            }
                            alt="company logo"
                            className="border-radius-10 mr-3 img-fit"
                            style={{ width: "48px", height: "48px" }}
                          />
                          <div className="job-info">
                            <h3
                              className="font-weight-medium mb-1 text-capitalize cursor-pointer text-primary"
                              onClick={() =>
                                onViewMentorProfileClick(
                                  data?.user_details &&
                                    data.user_details?.hash_id
                                )
                              }
                            >
                              {data?.user_details &&
                                data.user_details?.full_name}
                            </h3>
                            <p className="mb-1 fs-14 text-capitalize">
                              {data?.headline ? (
                                <>
                                  <span className="text-muted">
                                    {data?.headline}
                                  </span>
                                </>
                              ) : null}
                            </p>
                          </div>
                        </div>
                        <p className="font-weight-medium">
                          Location: {""}
                          {data?.city_name ? (
                            <span className="text-muted font-weight-400">
                              {data?.city_name}, {data?.state_name},{" "}
                              {data?.country_name}{" "}
                            </span>
                          ) : (
                            <span className="text-muted font-weight-400">
                              Not Mentioned
                            </span>
                          )}
                        </p>

                        <div className="d-flex align-items-center fs-smallest text-primary mb-3 flex-wrap">
                          {Array.isArray(data?.skills) &&
                            data?.skills &&
                            data.skills
                              .slice(0, 4)
                              .map((skill) => (
                                <p className="bg-light-blue text-capitalize bg-primary-light rounded-lg py-1 px-3 mr-2">
                                  {skill?.skill_name}
                                </p>
                              ))}
                          ...
                        </div>
                      </div>
                      <div className="d-flex align-items-center mt-3">
                        <div className="job-bottom d-flex align-items-center justify-content-between w-100">
                          <button
                            className="btn btn-primary ml-auto py-2"
                            onClick={() =>
                              onViewMentorProfileClick(
                                data?.user_details && data.user_details?.hash_id
                              )
                            }
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <EmptyFeedCard message={"no result found."} />
          )}
        </div>
      )}
    </div>
  );
}

export default MentorSearch;
